import gql from 'graphql-tag';

import { baseUserSettingsFragment } from '../fragments/baseUserSettings';

export default gql`
  query initialSettings($moduleName: String!, $viewName: String) {
    userSettings(moduleName: $moduleName, viewName: $viewName) {
      ...baseUserSettings
    }
    defaultColumns(moduleName: $moduleName) {
      # id
      header
      binding
      isReadOnly
      visible
      size
      isContentHtml
      aggregate
      align
      format
      wordWrap
    }
    defaultSorting(moduleName: $moduleName) {
      sorting {
        property
        ascending
      }
    }
    defaultGroupPanels(moduleName: $moduleName) {
      groups
    }
  }
  ${baseUserSettingsFragment}
`;
